import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { Location } from "@angular/common";

@Component({
  selector: "app-card-request-upload-id",
  templateUrl: "./card-request-upload-id.component.html",
  standalone:false,
  styleUrls: ["./card-request-upload-id.component.scss"],
})
export class CardRequestUploadIdComponent implements OnInit {
  constructor(private router: Router, private location: Location) {}

  ngOnInit(): void {}

  back() {
    this.location.back();
  }
  cardRequestConfrimDetails() {
    this.router.navigateByUrl("/CardRequestConfrimDetails");
  }
}
